import { render, staticRenderFns } from "./SeasonalCalendar.vue?vue&type=template&id=2b51646c&scoped=true&"
import script from "./SeasonalCalendar.vue?vue&type=script&lang=js&"
export * from "./SeasonalCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SeasonalCalendar.vue?vue&type=style&index=0&id=2b51646c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b51646c",
  null
  
)

export default component.exports